// Grammatica colori UNICA Pagamenti V2 + helper
export const STATUS_META = {
  incassato: { label: 'Incassato', dot: 'bg-emerald-500', text: 'text-emerald-700', bg: 'bg-emerald-50', border: 'border-emerald-200' },
  fatturato: { label: 'Fatturato non incassato', dot: 'bg-blue-500', text: 'text-blue-700', bg: 'bg-blue-50', border: 'border-blue-200' },
  da_fatturare: { label: 'Da fatturare', dot: 'bg-orange-500', text: 'text-orange-700', bg: 'bg-orange-50', border: 'border-orange-200' },
  non_sbloccato: { label: 'Non sbloccato', dot: 'bg-zinc-400', text: 'text-zinc-600', bg: 'bg-zinc-50', border: 'border-zinc-200' },
  scaduto: { label: 'Scaduto', dot: 'bg-rose-500', text: 'text-rose-700', bg: 'bg-rose-50', border: 'border-rose-200' },
};

export const CATEGORY_LABEL = {
  lavori: 'Lavori',
  arredi: 'Arredi',
  extra_forniture: 'Extra/Forniture',
};

export const fmtEuro = (n) =>
  new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(n || 0));

export const MONTHS = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];

export const daysSince = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  return Math.floor((Date.now() - d.getTime()) / 86400000);
};

// stato effettivo per colore timeline (scaduto ha priorità se determinabile)
export const effectiveStatus = (item) =>
  item.action_required === 'Scaduto' ? 'scaduto' : (item.status || 'da_fatturare');
